import React from 'react'
import './maintenance.scss'

export const ViewMaintenanceRequests = () => {
    return (
        <div className="main">
            <div className="container">
                <div className="content">
                    <div className="heading">
                        <h3>Maintenance requests</h3>
                    </div>
                </div>
            </div>
        </div>
    )
}
